import React, { Component } from 'react';
import PropTypes from 'prop-types';
import jQuery from 'jquery';

import NapsTable from './NapsTable';
import PriceHandler from '../utils/PriceHandler';
import sort, { numericSortFn, literalSortFn, oddsSortFn } from './utils/sort';

const isSameRow = data => row =>
    data.horseName === row.horseName &&
        data.courseName === row.courseName &&
        data.raceDate === row.date &&
        data.raceTime === row.diffusionTime;

class DataWrapper extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: props.data.map(item => ({
                ...item,
                key: `${item.horseId}-${item.diffusionTime}-${item.courseName}-${item.tipster}`,
            })),
            sortedBy: 'stakes',
        };

        this.clearPrices = this.clearPrices.bind(this);
        this.addPriceData = this.addPriceData.bind(this);
        this.onSort = this.onSort.bind(this);
        const tipsterSort = literalSortFn('tipster');
        this.sortConfig = {
            stakes: numericSortFn('levelStakes', tipsterSort),
            naps: literalSortFn('horseName', tipsterSort),
            time: literalSortFn('time', tipsterSort),
            crs: literalSortFn('crs', tipsterSort),
            tipster: tipsterSort,
            odds: oddsSortFn(tipsterSort),
        };
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.data !== nextProps.data) {
            this.setState({
                data: nextProps.data.map(item => ({
                    ...item,
                    key: `${item.horseId}-${item.diffusionTime}-${item.courseName}-${item.tipster}`,
                })),
            });
            jQuery(document).trigger('horsesListChanged');
        }
    }

    onSort(sortBy) {
        this.setState({ sortedBy: sortBy });
    }

    clearPrices() {
        this.setState({
            data: this.state.data.map(item => ({
                ...item,
                status: null,
                decimalPrice: null,
                bookmaker: null,
                fractionalPrice: null,
            })),
        });
    }

    addPriceData(priceData) {
        const data = [...this.state.data];
        const isItemAffected = isSameRow(priceData);
        const newData = data.map((item) => {
            if (!isItemAffected(item)) {
                return item;
            }
            return {
                ...item,
                bookmaker: priceData.bookmaker,
                status: priceData.status,
                decimalPrice: priceData.decimalPrice,
                fractionalPrice: priceData.fractionalPrice,
            };
        });
        this.setState({ data: newData });
    }

    render() {
        const { data, sortedBy } = this.state;
        const { loading } = this.props;
        const sortFn = this.sortConfig[sortedBy];
        const sortedData = (sortFn)
            ? sort(data, sortFn)
            : data;
        return (
            <div>
                <PriceHandler
                    onPriceReceived={this.addPriceData}
                    onClearPrices={this.clearPrices}
                />
                <NapsTable
                    sortedBy={this.state.sortedBy}
                    onSort={this.onSort}
                    data={sortedData}
                    loading={loading}
                />
            </div>
        );
    }
}

/**
 * Prop types validation
 * @type {{data: *, loading: *}}
 */
DataWrapper.propTypes = {
    data: PropTypes.arrayOf(PropTypes.shape({
        horseName: PropTypes.string,
        horseId: PropTypes.number,
        time: PropTypes.string,
        course: PropTypes.string,
        tipster: PropTypes.string,
        levelStake: PropTypes.number,
    })).isRequired,
    loading: PropTypes.bool.isRequired,
};

export default DataWrapper;



// WEBPACK FOOTER //
// ./src/js/napsTable/DataWrapper.js